import { FC } from "react";
import CustomLink from "@Components/CustomLink";

import { ContactCardProps } from "../../types";

import classes from "./ContactCard.module.scss";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";

const ContactCard: FC<ContactCardProps> = ({ icon, label, link }) => {
  const { t } = useTranslationHook();
  const handleClickEvent = () => {
    gtagEventEmitter({
      action: "bottom_button_clicked",
      category: "Footer Section",
      button_name: label,
    });
  };
  return (
    <CustomLink
      href={link}
      target="_blank"
      rel="noreferrer"
      isExternal
      className={classes.outerDiv}
      onClick={handleClickEvent}
      dataTestId={label}
    >
      {icon}
      <div className={classes.label}>{t(label)}</div>
    </CustomLink>
  );
};

export default wrapperHOC(ContactCard, {
  componentName: "ContactCard-FooterV2-Global",
  showForChina: true,
});
